module.exports = __webpack_public_path__ + "static/media/channel-kuara.18c5029f.svg";